import CityPageTemplate from "../city-template/CityPageTemplate";
import { rochesterHillsConfig } from "./data";

export default function RochesterHillsPage() {
  return <CityPageTemplate config={rochesterHillsConfig} />;
}